import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Typography, Button, Card, Image, Skeleton, Input } from "antd";

import EmptyState from "../../../shared/EmptyState";
import testImage from "../../../../assets/images/default-cover-image.jpg";
import FilterByDepartments from "../../../shared/FilterByDepartments";
import FilterByPositions from "../../../shared/FilterByPositions";
import { ReactComponent as SearchIcon } from "../../../../assets/images/search.svg";

const { Text } = Typography;

const EducatorOnboardingScreen = (props: any) => {
  const {
    onboardings,
    loading,
    loaded,
    actions: { getOnboarding },
  } = props;

  const [searchTerm, setSearchTerm] = useState("");
  const [filteredOnboardings, setFilteredOnboardings] = useState(onboardings);
  const [selectedDepartments, setSelectedDepartments] = useState<string[]>([]);
  const [selectedPositions, setSelectedPositions] = useState<string[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (loaded) return;
    getOnboarding();
  }, []);

  useEffect(() => {
    setFilteredOnboardings(
      onboardings.filter((onboarding: any) =>
        onboarding.title.toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  }, [searchTerm, onboardings]);

  const handleDepartmentChange = (departments: string[]) => {
    setSelectedDepartments(departments);

    let query = "";
    for (let i = 0; i < departments.length; i++) {
      query += "departmentIds=" + departments[i] + "&";
    }
    for (let i = 0; i < selectedPositions.length; i++) {
      query += "positionIds=" + selectedPositions[i] + "&";
    }

    getOnboarding({
      query,
    });
  };

  const handlePositionChange = (positions: string[]) => {
    setSelectedPositions(positions);

    let query = "";
    for (let i = 0; i < positions.length; i++) {
      query += "positionIds=" + positions[i] + "&";
    }
    for (let i = 0; i < selectedDepartments.length; i++) {
      query += "departmentIds=" + selectedDepartments[i] + "&";
    }

    getOnboarding({
      query,
    });
  };

  if (loading) {
    return <Skeleton active />;
  }

  return (
    <>
      {onboardings ? (
        <>
          <div className="flex flex-row gap-9">
            <Input
              placeholder="Search"
              prefix={<SearchIcon className="mx-3" />}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <Button
              type="primary"
              className="w-64 h-[50px] text-base leading-[18px] font-semibold"
              onClick={() => navigate("/educator/onboarding/create")}
            >
              Create New Onboarding
            </Button>
          </div>
          <div className="flex justify-end my-[18px]">
            <div className="flex justify-center w-[200px] gap-4">
              <FilterByDepartments
                onSelectionChange={handleDepartmentChange}
                selectedDepartments={selectedDepartments}
                setSelectedDepartments={setSelectedDepartments}
              />
              <FilterByPositions
                onSelectionChange={handlePositionChange}
                selectedPositions={selectedPositions}
                setSelectedPositions={setSelectedPositions}
              />
            </div>
          </div>
          <div className="flex flex-wrap gap-4 overflow-y-scroll max-h-[calc(100vh-290px)]">
            {filteredOnboardings.length > 0 ? (
              filteredOnboardings.map((content: any, index: any) => (
                <Card
                  key={content.id}
                  className="w-[calc(50%-0.5rem)] p-3 shadow-md"
                >
                  <div className="flex gap-4 h-full">
                    <div className="w-5/12 h-[130px]">
                      <Image
                        src={
                          content.coverImageKey
                            ? `${process.env.REACT_APP_CLOUDFRONT_KEY}/${content.coverImageKey}`
                            : testImage
                        }
                        preview={false}
                        className="rounded-lg object-cover"
                      />
                    </div>
                    <div className="flex flex-col justify-between w-7/12 gap-4">
                      <Text className="text-base text-neutral-600 font-semibold leading-[18px] line-clamp-3">
                        {content.title}
                      </Text>
                      <div>
                        <div className="flex w-full gap-4">
                          <Button
                            onClick={() =>
                              navigate(`/educator/onboarding/${content.id}`)
                            }
                            type="primary"
                            className="h-[24px] w-full bg-primary-600 font-semibold text-sm rounded-lg leading-[16px]"
                          >
                            View
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </Card>
              ))
            ) : (
              <div className="flex items-center w-full justify-center h-full py-[60px]">
                <EmptyState />
              </div>
            )}
          </div>
        </>
      ) : (
        <div className="flex items-center justify-center h-full pb-[60px]">
          <EmptyState />
        </div>
      )}
    </>
  );
};

export default EducatorOnboardingScreen;
